export const ProjectTypeValues = {
    Reconstruction: 'Реконструкция',
    CapitalConstruction: 'Капитальное строительство'
} as const;

export function normalizeProjectType(value?: string | null): string | null | undefined {
    switch (value) {
        case 'Департамент по реконструкции':
            return ProjectTypeValues.Reconstruction;
        case 'Департамент капитального строительства':
            return ProjectTypeValues.CapitalConstruction;
        default:
            return value;
    }
}
